let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9jswB")).then(() => parcelRequire('5DyWZ'));